/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//English (United Kingdom)
export default {
  'townsquare-comments.comment-action-bar.delete-button': 'Delete',
  'townsquare-comments.comment-action-bar.edit-button': 'Edit',
  'townsquare-comments.comment-action-bar.reply-button': 'Reply',
  'townsquare-comments.comment.edited-date': 'edited {time}',
  'townsquare-comments.comments.comments-title':
    '{itemCount, plural, =0 {Comments} one {# Comment} other {# Comments}}',
};
